/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Payport
 */
export class Payport {
    /**
     *
     * @type {string}
     * @memberof Payport
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Payport
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Payport
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof Payport
     */
    apiKey: string;
    /**
     *
     * @type {number}
     * @memberof Payport
     */
    merchantId: number;
    /**
     *
     * @type {boolean}
     * @memberof Payport
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Payport
     */
    autoApprove: boolean;
}
